(function checkTopLevelDomain() {
    var domainPieces = window.location.hostname.split('.');
    var domain = domainPieces[domainPieces.length - 1].toLowerCase();

    function addCssToHead(url) {
        var head = document.querySelector('head');
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = url;
        head.appendChild(link);
    }

    if (domain === 'ru' || domain === 'ua') {
        // Add CSS to head, in order to load cyrillic fonts
        addCssToHead(window.environment.staticDirectory + 'css/cyrillic.css');
    }
})();
